<template>
	<div class="culture">
		<p>COMPANY CULTURE</p>
		<h3>公司文化</h3>
		<div class="container">
			<div class="content clearfix">
				<div v-html="cultrue"></div>
			</div>
		
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'culture',
				cultrue:'',
			}
		},
		methods:{
			getData(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.cultrueApi,
				})
				.then((res) => {
					this.cultrue = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.$parent.getItem();
			this.getData();
		}
	}
</script>

<style lang="less" scoped="scoped">
.culture{
	P{
		margin-top: 50px;
		font-size: 26px;
		color: #00A0FF;
		text-align:center;
	}
	h3{
		margin-top: 10px;
		font-size: 26px;
		font-weight: 600;
		margin-bottom: 50px;
		text-align:center;
	}
	.content{
		margin-top: 20px;
		p{
			margin-bottom: 50px;
			font-size: 15px;
		}
		.classify{
			i{
				display: inline-block;
				width: 6px;
				height: 6px;
				background: #146BFF;
			}
			h3{
				display: inline-block;
				margin-left: 15px;
				font-size: 18px;
				margin-bottom: 20px;
			}
		}
	}
}

</style>


// WEBPACK FOOTER //
// src/components/pages/About/Acom/Culture.vue